// hooks
import useThemeMode from "Utils/useThemeMode";

// assets
import logo from "Assets/logo-black-red.svg";
import whiteLogo from "Assets/logo-rgb-white.svg";

// styles
import styles from "./LoginForm.module.css";

export default function LoginLogo() {
    // Which logo *file* to load is a genuine JS decision — CSS cannot swap an
    // <img src>. Every other themed value comes from Styles/tokens.css.
    const mode = useThemeMode();
    const src = mode === "light" ? logo : whiteLogo;

    return <img src={src} className={styles.logo} alt="logo" />;
}
